export default __webpack_public_path__ + "tensorflow.aa496d19.png";